import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import Dashboard_Icon from '../../assets/images/Dashboard_Icon.png';
import ProductIcon from '../../assets/images/ProductIcon.png';
import OrderIcon from '../../assets/images/OrderIcon.png';
import Helper from "./../../utils/helper";

const SideMenu = () => {
  const location = useLocation();
  const [menuItems, setMenuItems] = useState([]);
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const selectedKeys = pathname.substring(pathname.lastIndexOf('/') + 1).replace(/[^a-zA-Z0-9]/g, '');
  const [namePage, setNamePage] = useState(page);

  const menuData = [
    {
      key: 'dashboard',
      label: 'Dashboard',
      icon: <img src={Dashboard_Icon} alt="dashboard" style={{ width: '28px', height: '28px' }} />,
      path: '/dashboard',
    },
    {
      key: 'product',
      label: 'Quản lý sản phẩm',
      icon: <img src={ProductIcon} alt="product" style={{ width: '28px', height: '28px' }} />,
      path: '/product',
    },
    {
      key: 'order',
      label: 'Quản lý đơn',
      icon: <img src={OrderIcon} alt="order" style={{ width: '28px', height: '28px' }} />,
      path: Helper.getParamUrlByKey('orderCode')?`/order?orderCode=${Helper.getParamUrlByKey('orderCode')}`:'/order',
      // children: options
    },
  ];
  

  return (
    <Menu
      mode="inline"
      theme="light"
      // openKeys={'order'}
      defaultSelectedKeys={[selectedKeys]}
      style={{ borderRight: 0, width: '100%' }}
    >
      {menuData.map((item) =>
        item?.children ? (
          <Menu.SubMenu
            key={item?.key}
            icon={item?.icon}
            title={item?.label}
          >
            {item?.children?.map((child) => (
              <Menu.Item style={{paddingLeft: 62}} key={child.key}>
                <Link  to={child.path}>{child.label}</Link>
              </Menu.Item>
            ))}
          </Menu.SubMenu>
        ) : (
          <Menu.Item key={item.key} icon={item.icon} >
            <Link to={item.path}>{item.label}</Link>
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

export default SideMenu